<ng-container *transloco="let t">
<ng-template #consent>
  <div id="consent-authorization-main" class="container">
    <div class="card">
      <div class="card-body fs-6 p-6 p-lg-15">
        @if (showEConsentVerbiage) {
          <div id="eConsentContainer" [innerHtml]="eBusinessConsentVerbiage | safeHtml"></div>
        }
        <div class="py-6">
          <h2 class="anchor fw-bolder mb-2" id="layout">{{ t('wizard.consent.consentToDoBusinessElectronically') }}</h2>
          <div class="col-lg-12 fv-row mb-6">
            <div class="d-flex align-items-center mt-3">
              <label class="form-check form-check-inline form-check-solid me-5">
                <input class="form-check-input" required name="consentToDoBusinessCheckbox" #consent="ngModel"
                  [disabled]="hasAlreadyValidEConsent"
                  [ngClass]="{'is-invalid' : consent && consent.touched && consent.invalid}"
                  [(ngModel)]="eConsentGiven" type="checkbox" />
                <span class="fw-bold ps-2 fs-6 required">{{ t('wizard.consent.iWeConsent') }}</span>
                <div class="invalid-feedback">{{ t('wizard.consent.consentIsRequired') }}</div>
              </label>
            </div>
          </div>
        </div>
        @if (!creditCheckConsentAlreadyGiven) {
          <div>
            <h2 class="anchor fw-bolder" id="layout">{{ t('wizard.consent.consentToRunCredit') }}</h2>
              @if (showCreditAuthVerbiage) {
                <div id="creditCheckConsentContainer" [innerHtml]="creditCheckConsentVerbiage | safeHtml"></div>
              }
              <div class="col-lg-12 fv-row mb-6">
                <div class="d-flex align-items-center mt-3">
                  <label class="form-check form-check-inline form-check-solid me-5">
                    <input class="form-check-input" required name="consentToDoCreditCheckAuthorizationCheckbox"
                      #consentForCreditCheck="ngModel"
                      [ngClass]="{'is-invalid' : consentForCreditCheck && consentForCreditCheck.touched && consentForCreditCheck.invalid}"
                      [(ngModel)]="creditCheckConsentGiven" type="checkbox" />
                    <span class="fw-bold ps-2 fs-6 required">{{ t('wizard.consent.iWeConsent') }}</span>
                    <div class="invalid-feedback">{{ t('wizard.consent.consentIsRequired') }}</div>
                  </label>
                </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>

<wizard-step-template [stepMainTemplate]="consent" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
